/* NEW PORT VELA - V3 homepage: sea entrance, scroll turn, range filters */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  var body = document.body;

  /* =====================================================================
     ENTRANCE - the approved sea hero. Shown on the first visit of the
     session; afterwards the store opens directly. ?intro=1 replays it.
     ===================================================================== */
  var intro = $('#intro'), tide = $('#tide'), tideBand = $('#tideBand');
  var introWrap = intro ? intro.closest('.shopify-section') : null;
  if (introWrap) introWrap.classList.add('shopify-section--intro');
  var outside = function () {
    return $$('.site-header, .site-footer, #main > .shopify-section').filter(function (el) { return el !== introWrap; });
  };
  var state = { phase: 'store' }, timer = 0, arriveTimer = 0, revealed = false;

  function setInert(on) { outside().forEach(function (el) { if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); }); }

  if (intro) {
    var video = $('#seaVideo'), enterBtn = $('#enterBtn'), glow = $('#introGlint');
    var params = null; try { params = new URLSearchParams(location.search); } catch (e) {}
    /* one entrance per language and session: switching ES/EN shows the sea again */
    var seenKey = 'npv_intro_seen_' + (document.documentElement.lang || 'x').slice(0, 2);
    var seen = false; try { seen = !!sessionStorage.getItem(seenKey); } catch (e) {}
    var wantsIntro = params && params.get('intro') === '1';
    var skipByLink = (params && params.get('v3') === 'store') || location.hash === '#coleccion' || location.hash === '#store';
    /* visitors from Instagram, Facebook, TikTok, ads, DMs or any tagged link open on the products: the in-app
       browsers start a fresh session on every tap, so the sea gate hit 100 % of them (73 % bounce, 0 carts
       in 23 days). The entrance stays for people who type the address. */
    var ua = navigator.userAgent || '';
    var inApp = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|TikTok|musical_ly|Bytedance|Twitter|LinkedInApp|Pinterest|Snapchat/i.test(ua);
    var tagged = !!(params && (params.get('utm_source') || params.get('utm_medium') || params.get('fbclid') || params.get('gclid') || params.get('ttclid')));
    var social = /\b(instagram|facebook|tiktok|pinterest)\.com\b|\/\/(t\.co|fb\.me)\//i.test(document.referrer || '');
    if (inApp || tagged || social) skipByLink = true;

    function videoFailed() { if (video) video.hidden = true; var f = $('#seaFallback'); if (f) f.hidden = false; }
    if (video) { video.addEventListener('error', function () { if (video.getAttribute('src')) videoFailed(); }); }
    function playVideo() {
      if (!video) return;
      if (document.documentElement.classList.contains('no-inline-video')) { videoFailed(); return; }
      /* data saver or 2G: the sea stays on its poster (about 1 MB of video saved) */
      var lite = false; try { var nc = navigator.connection; lite = !!(nc && (nc.saveData || /(^|-)2g$/.test(nc.effectiveType || ''))); } catch (e) {}
      if (lite && !video.getAttribute('src')) return;
      if (!video.getAttribute('src')) { var small = window.matchMedia && window.matchMedia('(max-width: 760px)').matches; video.src = (small ? video.getAttribute('data-src-sd') : video.getAttribute('data-src-hd')) || video.getAttribute('data-src-hd'); }
      var p = video.play && video.play(); if (p && p.catch) p.catch(function () {});
    }

    var vw = window.innerWidth, vh = window.innerHeight;
    window.addEventListener('resize', function () { vw = window.innerWidth; vh = window.innerHeight; });
    var ptr = { x: 0, y: 0, rest: true, raf: 0 };
    function applyPointer() {
      ptr.raf = 0;
      if (ptr.rest) { intro.style.removeProperty('--mx'); intro.style.removeProperty('--my'); if (glow) glow.classList.remove('is-on'); return; }
      var nx = (ptr.x / vw - 0.5) * 2, ny = (ptr.y / vh - 0.5) * 2;
      intro.style.setProperty('--mx', nx.toFixed(3)); intro.style.setProperty('--my', ny.toFixed(3));
      if (glow) { glow.style.transform = 'translate3d(' + ptr.x + 'px,' + ptr.y + 'px,0)'; glow.classList.add('is-on'); }
    }
    function onMove(ev) { if (state.phase !== 'intro') return; ptr.x = ev.clientX; ptr.y = ev.clientY; ptr.rest = false; if (!ptr.raf) ptr.raf = requestAnimationFrame(applyPointer); }
    function onLeave() { if (state.phase !== 'intro') return; ptr.rest = true; if (!ptr.raf) ptr.raf = requestAnimationFrame(applyPointer); }
    if (!reduce && !coarse) { window.addEventListener('pointermove', onMove, { passive: true }); window.addEventListener('pointerleave', onLeave, { passive: true }); }

    function revealStore() {
      /* back to the top once, while scrolling is still locked: a later scrollTo (the tide ends ~.8s after
         the reveal) yanked shoppers who had already started scrolling back to the top */
      if (!revealed) { revealed = true; var de = document.documentElement, sb = de.style.scrollBehavior; de.style.scrollBehavior = 'auto'; window.scrollTo(0, 0); de.style.scrollBehavior = sb; }
      intro.hidden = true; intro.setAttribute('aria-hidden', 'true');
      if (video) video.pause();
      body.classList.remove('is-intro');
      body.classList.add('store-arrives');
      /* the landing animation lasts .7s; drop the class so no section keeps an animation afterwards */
      clearTimeout(arriveTimer); arriveTimer = setTimeout(function () { body.classList.remove('store-arrives'); }, 1000);
    }
    function showStore(instant) {
      clearTimeout(timer); timer = 0;
      if (ptr.raf) { cancelAnimationFrame(ptr.raf); ptr.raf = 0; }
      state.phase = 'store';
      revealStore();
      if (instant) body.classList.remove('store-arrives');
      if (tide) tide.classList.remove('is-active');
      intro.classList.remove('is-leaving', 'is-skipping');
      setInert(false);
      try { sessionStorage.setItem(seenKey, '1'); } catch (e) {}
      if (!instant) { var m = $('#main'); if (m) m.focus({ preventScroll: true }); }
      window.dispatchEvent(new Event('npv:store'));
    }
    if (tideBand) tideBand.addEventListener('animationend', function () { if (state.phase === 'leaving') showStore(false); });
    function enter() {
      if (state.phase !== 'intro') return;
      state.phase = 'leaving';
      if (reduce) { showStore(false); return; }
      intro.classList.add('is-leaving');
      if (tide) tide.classList.add('is-active');
      timer = setTimeout(revealStore, 760);
      /* safety net: background tabs pause CSS animations, so animationend may never come */
      setTimeout(function () { if (state.phase === 'leaving') showStore(false); }, 2600);
    }
    function skip() {
      if (state.phase !== 'intro') return;
      state.phase = 'leaving';
      if (reduce) { showStore(false); return; }
      intro.classList.add('is-skipping');
      timer = setTimeout(function () { showStore(false); }, 190);
    }
    function startIntro() {
      state.phase = 'intro';
      revealed = false;
      body.classList.add('is-intro');
      body.classList.remove('store-arrives');
      intro.hidden = false; intro.removeAttribute('aria-hidden');
      intro.classList.remove('is-leaving', 'is-skipping');
      setInert(true);
      ptr.rest = true; applyPointer();
      window.scrollTo(0, 0);
      if (!reduce) { try { if (video) video.currentTime = 0; } catch (e) {} playVideo(); } else if (video) video.pause();
      if (enterBtn) enterBtn.focus({ preventScroll: true });
    }
    if (enterBtn) enterBtn.addEventListener('click', enter);
    var skipBtn = $('#skipBtn'); if (skipBtn) skipBtn.addEventListener('click', skip);
    $$('[data-replay]').forEach(function (b) { b.addEventListener('click', startIntro); });
    document.addEventListener('keydown', function (ev) {
      if (state.phase !== 'intro') return;
      var tag = ev.target && ev.target.tagName;
      if (ev.key === 'Escape') { ev.preventDefault(); skip(); return; }
      if (ev.key === 'Enter' || ev.key === ' ') { if (tag === 'BUTTON' || tag === 'A') return; ev.preventDefault(); enter(); }
    });

    if (wantsIntro || (!seen && !skipByLink)) { startIntro(); }
    else { showStore(true); }
  }

  /* =====================================================================
     VITRINA 360 — tabs choose the garment; NPV.Spin does the turning.
     ===================================================================== */
  var vit = $('[data-vitrina]');
  if (vit && window.NPV && NPV.Spin) {
    var tabs = $$('[data-vit-tab]', vit), panels = $$('[data-vit-panel]', vit), cur = 0;
    var spinFor = function (i) { var el = panels[i] && panels[i].querySelector('.vit__spin:not([hidden]) [data-spin]'); return el ? (el.__spin || new NPV.Spin(el)) : null; };
    /* colour (or force) buttons: swap the 360 and the product link */
    panels.forEach(function (panel) {
      var link = panel.querySelector('[data-vit-link]');
      var wraps = $$('.vit__spin', panel), btns = $$('[data-vit-color]', panel);
      var setLink = function () { var on = panel.querySelector('.vit__spin:not([hidden])'); if (link && on && on.getAttribute('data-url')) link.href = on.getAttribute('data-url'); };
      setLink();
      var choose = function (idx, focus) {
        wraps.forEach(function (w) {
          var on = w.getAttribute('data-vit-spin') === String(idx);
          var sEl = w.querySelector('[data-spin]');
          if (!on && !w.hidden && sEl && sEl.__spin) sEl.__spin.stop();
          w.hidden = !on;
        });
        btns.forEach(function (b) { var on = b.getAttribute('data-vit-color') === String(idx); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (on && focus) b.focus(); });
        setLink();
        if (!panel.hidden) { var s = spinFor(panels.indexOf(panel)); if (s) s.start(); }
      };
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () { choose(b.getAttribute('data-vit-color'), false); });
        b.addEventListener('keydown', function (e) {
          var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (!d) return; e.preventDefault();
          var nb = btns[(k + d + btns.length) % btns.length]; choose(nb.getAttribute('data-vit-color'), true);
        });
      });
    });
    var select = function (i, focus) {
      if (i < 0) i = tabs.length - 1; if (i >= tabs.length) i = 0;
      if (i === cur && !focus) return;
      var old = spinFor(cur); if (old && i !== cur) old.stop();
      tabs.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      cur = i;
      var s = spinFor(i); if (s) s.start();
      var t = tabs[i];
      if (focus) t.focus();
      var list = t.parentNode;
      if (list.scrollWidth > list.clientWidth) { var l = t.offsetLeft - list.clientWidth / 2 + t.clientWidth / 2; try { list.scrollTo({ left: l, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { list.scrollLeft = l; } }
      /* warm the next garment's video poster/frames lightly */
      var nx = panels[(i + 1) % panels.length]; if (nx) { var ns = nx.querySelector('[data-spin-video]'); if (ns) ns.preload = 'metadata'; }
    };
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { select(k, false); });
      t.addEventListener('keydown', function (e) {
        var vertical = window.innerWidth > 900;
        var next = vertical ? 'ArrowDown' : 'ArrowRight', prev = vertical ? 'ArrowUp' : 'ArrowLeft';
        if (e.key === next) { e.preventDefault(); select(cur + 1, true); }
        else if (e.key === prev) { e.preventDefault(); select(cur - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); select(0, true); }
        else if (e.key === 'End') { e.preventDefault(); select(tabs.length - 1, true); }
      });
    });
    spinFor(0);
    window.addEventListener('npv:store', function () { var s = spinFor(cur); if (s) s.start(); });
  }

  /* =====================================================================
     RANGE FILTERS - client-side, by collection handle
     ===================================================================== */
  var filters = $('[data-range-filters]'), grid = $('[data-range-grid]');
  if (filters && grid) {
    var items = $$('li', grid), countEl = $('[data-range-count]'), emptyEl = $('[data-range-empty]');
    $$('.chip', filters).forEach(function (chip) {
      chip.addEventListener('click', function () {
        var h = chip.getAttribute('data-filter') || '';
        var visible = 0;
        items.forEach(function (li) { var on = !h || (' ' + (li.getAttribute('data-cols') || '') + ' ').indexOf(' ' + h + ' ') !== -1; li.hidden = !on; if (on) visible++; });
        $$('.chip', filters).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        if (countEl) countEl.textContent = visible;
        if (emptyEl) emptyEl.hidden = visible > 0;
      });
    });
  }
})();
